import React from "react";
import Page from "../components/Page";
import ContactForm from "../components/ContactForm";

export default class extends React.Component {
  render() {
    return (
      <Page>
        <ContactForm />
      </Page>
    );
  }
}
